// extracted by mini-css-extract-plugin
module.exports = {"difficultLessonsCardContainer":"styles_difficultLessonsCardContainer__1zJBd","lessonItem":"styles_lessonItem__2oifO"};